import { forwardRef } from "react";
import {
  Link as RLink,
  NavLink as RNavLink,
  Navigate as RNavigate,
  useNavigate as rUseNavigate,
  useLocation,
} from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

export const LANGS = ["de", "en", "fr", "es"];

export const langFromPath = (pathname) => {
  const seg = pathname.split("/")[1];
  return LANGS.includes(seg) && seg !== "de" ? seg : "de";
};

export const stripLang = (pathname) => {
  const seg = pathname.split("/")[1];
  return LANGS.includes(seg) && seg !== "de" ? pathname.slice(seg.length + 1) || "/" : pathname;
};

export const withLang = (to, lang) => {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("/admin")) return to;
  const base = stripLang(to);
  return lang === "de" ? base : `/${lang}${base === "/" ? "" : base}`;
};

export const useLocalePath = () => {
  const { lang } = useLanguage();
  return (to) => withLang(to, lang);
};

export const Link = forwardRef(({ to, ...rest }, ref) => {
  const lp = useLocalePath();
  return <RLink ref={ref} to={lp(to)} {...rest} />;
});

export const NavLink = forwardRef(({ to, ...rest }, ref) => {
  const lp = useLocalePath();
  return <RNavLink ref={ref} to={lp(to)} {...rest} />;
});

export const Navigate = ({ to, ...rest }) => {
  const lp = useLocalePath();
  return <RNavigate to={lp(to)} {...rest} />;
};

export const useNavigate = () => {
  const nav = rUseNavigate();
  const lp = useLocalePath();
  return (to, opts) => nav(typeof to === "string" ? lp(to) : to, opts);
};

export const useBasePath = () => stripLang(useLocation().pathname);
